import React from 'react'
import CardCarousel from '../../components/Carousel/CardCarousel'

const ContentPage = () => {
  return (
    <>
      <h1 align="center">Examples of advertisement.</h1>
      <CardCarousel />
    </>    
  )
}
export default ContentPage